import MoveNSeconds from '../MoveNSeconds'

const BackwardsNSeconds = MoveNSeconds(true)

export default BackwardsNSeconds
